<template>
  <div class="product-gift-component">
    <div v-if="visible"
         class="gift-container"
         @click="handleClickGiftIcon"
    >
      <ym-icon class="icon-gift"
               name="gift"
      />
      <span class="product-gift-desc">赠送</span>
    </div>
    <confirm-pay-popup :show.sync="showPayPopup"
                       show-num
                       :target-id="benefitPopupTargetId"
                       :target-type="benefitPopupTargetType"
                       :title="benefitPopupTargetTitle"
                       :recommend="mixinRecommendBenefit"
                       :benefits="mixinBenefits"
                       :price="mixinShouldPay"
                       :modal-guide-info="modalGuideInfo"
                       :rule="mixinPopupPayRule"
    />
  </div>
</template>

<script>
  import ConfirmPayPopup from '@/components/ConfirmPayPopup';
  import joinProductMixin from '@/mixins/order/joinProduct';
  import validator from '@/utils/validator';

  export default {
    name: 'ProductGift',
    mixins: [joinProductMixin],
    components: {
      ConfirmPayPopup,
    },
    data() {
      return {
        disabled: false,
        visible: false,
      };
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      targetId: {
        type: Number,
        required: true,
      },
      targetType: {
        type: String,
        required: true,
      },
      targetTitle: {
        type: String,
        required: true,
      },
      modalGuideInfo: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      originPrice: {
        type: Number,
      },
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      showPayPopup(val) {
        if (!val) {
          this.disabled = false;
        }
      },
    },
    methods: {
      async handleClickGiftIcon() {
        if (this.disabled) return;
        this.disabled = true;
        try {
          const { targetType, targetId } = this;
          const product = {
            targetId,
            targetType,
            hint: '赠送',
            page: this.$route.name,
            price: this.originPrice,
          };
          await this.mixinHandleClickJoinBtn(product);
        } catch (e) {
          this.disabled = false;
        }
      },
    },
    created() {
      this.visible = this.show;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-gift-component {
    flex-shrink: 0;
  }

  .gift-container {
    width: 140px;
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    color: @color-white;
    font-size: @font-size-base;
    background: @color-primary;
    border-radius: 27px;
  }

  .icon-gift {
    font-size: 24px;
    color: @color-white;
    margin-right: @size-extra-small;
  }
</style>
